import { NextSeo, SiteLinksSearchBoxJsonLd } from 'next-seo';
import Head from 'next/head';
import { useEffect, useMemo, useState } from 'react';
import { BrandName } from '../../Constants/ProductPage';
import { getSEOUtils } from '../../Utils/StoreHomePageUtils';
import { fireEventForRepeatUser } from '../../Utils/useFirebase';
import { getSeoVisibility } from '../../appconfig';
import GlobalStyle from '../../styles/globalStylesV2';
import GeneralItemListing from './GeneralItemListing/GeneralItemListing';
import TopCarousel from './TopCarousel';
import LazyLoad from 'react-lazyload';
import TrustSection from '../NewStoreHomeWeb/TrustSection/TrustSection';
import { fireEvent } from '../../Utils/fireEvent';
import { getGeneralItemByItemId } from '../../datafetchers/Store';
import { getWebUserId } from '../../Utils/helper';
import ScrollWrapper from '../ScrollWrapper/ScrollWrapper';


export default function StoreHomeMainComponent(props) {
  const { brand, metaDescHome, metaTitleHome, storeData, categoryCardsData } =
    props;
  const [changeCartCount, setChangeCartCount] = useState();
  const [generalItems, setGeneralItems] = useState([]);
  const webUserId = getWebUserId();

  let { metaTitle, metaDesc, openGraphData } = getSEOUtils(brand);

  if (metaTitleHome) {
    metaTitle = metaTitleHome;
    openGraphData['title'] = metaTitle;
  }
  if (metaDescHome) {
    metaDesc = metaDescHome;
    openGraphData['description'] = metaDesc;
  }

  const memoisedBanners = useMemo(() => {
    const items = storeData?.items;
    const BannerComponents = [];
    items?.forEach((element,index) => {
      switch (element?.viewType) {
        case 'CAROUSEL':
          // Create impression data
        const impressionData = {
          category: 'impression_section_in_store_home',
          section_id: element?._id || element?.id,
          section_name: element?.heading || element?.itemName || 'Top Carousel',
          shape: 'CAROUSEL',
          deeplink_value: element?.deeplinkValue,
          card_ids: element?.items?.map(item => item?._id)?.join(',')?.slice(0, 99) || '',
          section_index: index
        };
          BannerComponents.push(
             <ScrollWrapper
            key={`carousel_${element?.itemName}_${index}`}
            sectionId={`carousel_${index}`}
            data={impressionData}
            fromStoreHome={true}
          >
            <TopCarousel
              banner={element}
              type={element?.viewType}
              key={element?.itemName}
              StoreHome={true}
              //catHideHeader={true}
              noMobileCategory={true}
            />
             </ScrollWrapper>
          );
      }
    });
    return BannerComponents;
  }, [storeData?.items]);

  const makeDynamicGeneralItems = async () => {
    const INTRO_OFFER_ITEM_ID = 6094;
    const REORDER_GENERAL_ITEM__ID = 5788;
    const items = await Promise.all([
      getGeneralItemByItemId(INTRO_OFFER_ITEM_ID),
      getGeneralItemByItemId(REORDER_GENERAL_ITEM__ID),
    ]);
    setGeneralItems(items);
  };

  useEffect(() => {
    fireEvent({
      category: 'viewed_shop_home',
      screen_name: 'STORE_HOME',
    });

    fireEventForRepeatUser('store_home');
    makeDynamicGeneralItems();

    const event = new CustomEvent('page_view_kp', {
      detail: {
        type: 'other',
        data: {
          cart_id: webUserId,
        },
      },
    });
    window.dispatchEvent(event);
  }, []);

  return (
    <>
      {getSeoVisibility() ? (
        <>
          <Head>
            <link
              rel="preload"
              as="image"
              href="https://images.myloapp.in/NestJsUploads/1682404377508-myloLogo.svg"
            />
          </Head>
          <SiteLinksSearchBoxJsonLd
            url="https://mylofamily.com/"
            name={BrandName}
            potentialActions={[
              {
                target: 'https://mylofamily.com/search?tag=products&q',
                queryInput: 'search_term_string',
              },
            ]}
          />
          <NextSeo
            title={metaTitle}
            description={metaDesc}
            openGraph={openGraphData}
            noindex={brand != 'store' ? true : false}
            nofollow={brand != 'store' ? true : false}
          />
        </>
      ) : null}
      <GlobalStyle />
      {memoisedBanners}

      <GeneralItemListing
        setChangeCartCount={setChangeCartCount}
        data={storeData}
        categoryCardsData={categoryCardsData}
        generalItems={generalItems}
      />
      <LazyLoad once offset={10} height={300}>
        <TrustSection />
      </LazyLoad>
    </>
  );
}
